import { render, staticRenderFns } from "./bagNumber.vue?vue&type=template&id=728354c3&scoped=true"
import script from "./bagNumber.vue?vue&type=script&lang=js"
export * from "./bagNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728354c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('728354c3')) {
      api.createRecord('728354c3', component.options)
    } else {
      api.reload('728354c3', component.options)
    }
    module.hot.accept("./bagNumber.vue?vue&type=template&id=728354c3&scoped=true", function () {
      api.rerender('728354c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/preLoadTruckPickup/bagNumber.vue"
export default component.exports